import { EntInitialFilterName } from "../../../models/filters/initialFilterName";
import { EntDepartment } from "../../../models/handBooks/department";
import { ResponseDataGet } from "../../../models/responseDataGet";
import { agroApi } from "../api";
import { Paths } from "../../../paths";

export const departmentApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({
	getDepartmentList: builder.query<ResponseDataGet<EntDepartment>, EntInitialFilterName>({
	  query: (filter) => ({
		url: `${ Paths.handbooks.departments }/get-all`,
		method: "POST",
		body: JSON.stringify(filter),
	  }),
	}),

	getDepartmentById: builder.query<ResponseDataGet<EntDepartment>, number>({
	  query: (id) => ({
		url: `${ Paths.handbooks.departments }/${ id }`,
		method: 'GET',
	  }),
	}),

	addDepartment: builder.mutation<ResponseDataGet<EntDepartment>, EntDepartment>({
	  query: (body) => ({
		url: `${ Paths.handbooks.departments }`,
		method: "POST",
		body: JSON.stringify(body),
	  }),
	}),

	editDepartment: builder.mutation<ResponseDataGet<EntDepartment>, EntDepartment>({
	  query: (body) => ({
		url: `${ Paths.handbooks.departments }`,
		method: 'PUT',
		body: JSON.stringify(body),
	  }),
	}),

	deleteDepartment: builder.mutation<ResponseDataGet<EntDepartment>, number>({
	  query: (id) => ({
		url: `${ Paths.handbooks.departments }/${ id }`,
		method: 'DELETE',
	  }),
	}),
  }),
  overrideExisting: false,
});

export const {
  useAddDepartmentMutation,
  useDeleteDepartmentMutation,
  useEditDepartmentMutation,
  useLazyGetDepartmentListQuery
} = departmentApi;
